import { render, staticRenderFns } from "./SAASColSet2.vue?vue&type=template&id=7aa9d0d6"
import script from "./SAASColSet2.vue?vue&type=script&lang=js"
export * from "./SAASColSet2.vue?vue&type=script&lang=js"
import style0 from "./SAASColSet2.vue?vue&type=style&index=0&id=7aa9d0d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports